import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Output } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { OrderService } from "../../../order.service";
import { debounceTime, take, takeUntil, tap } from "rxjs/operators";
import { Customer, CustomerDetailInfoViewModel } from "../../../../parties/model/customer.model";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { CustomerFilter } from "../../../model/customer-filter.model";
import { CallCustomerList, CallRead } from "../../../model/call-read.model";
import { NotificationService } from "projects/sepidz-web-framework/src/lib/services/notification.service";
import { SimpleModalService } from "projects/sepidz-web-framework/src/lib/services/sepidzmodal/simple-modal.service";
import { CustomerOrderService } from "../../../customerorder/customerorder.service";
// import { ThousandSeparatorPipe } from "projects/sepidz-web-framework/src/lib/pipes/thousand-separator.pipe";
// import { InvoiceService } from "../../invoice/invoice.service";

@Component({
  selector: "order-customerfastaccess",
  templateUrl: "./customerfastaccess.component.html",
  styleUrls: ["./customerfastaccess.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomerFastAccessComponent extends BaseListComponent {
  _customers: Customer[];
  _ToDayCallList: CallCustomerList[];
  _RingingMissCallList: CallRead[];
  _allowSearch: boolean = false;
  _isCreateFormGroup: boolean = false;
  moreInfo: Customer;
  @Output() StayOnPage: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    __id: FormContainerModel,
    public dialog: SimpleModalService,
    private notification: NotificationService,
    public cd: ChangeDetectorRef,
    public customerService: CustomerOrderService,
    public order: OrderService // private invoiceService: InvoiceService
  ) {
    super();
    this.currentTabId = __id.metadata.id;
    this.order.cd_FastAccessCustomer = cd;
  }
  ngOnInit() {
    this.apiName = "Customer/GetFilterGrid";
    this.areaName = "RestaurantSale";
    this._customers = [];
    this.GetCustomersPagination(10);
    this.getRingingMissCallList();
    this.getToDayCallList();
    let group: any = {};
    group["inputName"] = new UntypedFormControl(null, null);
    group["inputNumber"] = new UntypedFormControl(null, null);
    group["inputPhone"] = new UntypedFormControl(null, null);
    group["inputAddress"] = new UntypedFormControl(null, null);
    this.group = new UntypedFormGroup(group);
    this._isCreateFormGroup = true;

    this.init();
  }

  private init() {
    this.notification.init();
    this.notification.notification$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((value) => {
      if (value.Key === "CallerIdNotification") {
        this.getToDayCallList();
        this.getRingingMissCallList();
      }
    });
  }

  GetCustomersPagination(numberOfCustomer: number) {
    this.httpCommonService
      .getItem("Customer/GetCustomerByNumber", numberOfCustomer)
      .pipe(take(1))
      .subscribe((customers: Customer[]) => {
        this._customers = customers.sort((a, b) => a.Number - b.Number);
        this.cd.markForCheck();
      });
  }
  getToDayCallList() {
    this.httpCommonService
      .getItem("CallerId/ToDayCallList", this.order.logInBranch.Id)
      .pipe(take(1))
      .subscribe((toDayCallList: CallCustomerList[]) => {
        this._ToDayCallList = toDayCallList;
        this._ToDayCallList.forEach((x) => {
          if (x.CustomerName) {
            return x.CustomerName;
          } else {
            return x.CustomerName == this.translate("ClientApp.FrontOffice.Order.OrderPage.Fastaccess.CustomerFastacces.NoSubscription");
          }
        });
        this.cd.markForCheck();
      });
  }
  getRingingMissCallList() {
    this.httpCommonService
      .getItem("CallerId/RingingMissCallList", this.order.logInBranch.Id)
      .pipe(take(1))
      .subscribe((ringingMissCallList: CallRead[]) => {
        this._RingingMissCallList = ringingMissCallList;
        this.cd.markForCheck();
      });
  }
  FilterName() {
    //setTimeout(() => {
    let inputName, inputNumber, inputPhone, inputAddress: string;
    inputName = this.group.controls["inputName"].value;
    inputNumber = this.group.controls["inputNumber"].value;
    inputPhone = this.group.controls["inputPhone"].value;
    inputAddress = this.group.controls["inputAddress"].value;

    var customerFilter = new CustomerFilter();
    customerFilter.DisplayName = inputName;
    customerFilter.Code = inputNumber;
    customerFilter.PhoneNumber = inputPhone;
    customerFilter.Address = inputAddress;

    this.httpCommonService
      .create("Customer/GetCustomersByFilter", customerFilter)
      .pipe(take(1))
      .subscribe((x: Customer[]) => {
        this._customers = x;
        this.cd.markForCheck();
      });
    //}, 2000);
  }
  //پر کردن نام مشتری در فاکتور جاری
  SetInvoiceCustomerName(customerId: number) {
    this.httpCommonService
      .getItem("Customer/GetCustomerDetails", customerId)
      .pipe(take(1))
      .subscribe(
        async (customer: CustomerDetailInfoViewModel) => {
          if (this.order.invoice.CustomerId !== customer.Id || customer.Addresses.length > 0) {
            this.order.invoice.ShippingCost = 0;
            this.order.invoice.CourierShippingCost = 0;
            this.order.invoice.Discount = 0;
            this.customerService.setCostomerInfo(null, customer);

            this.order.closeSidebar();
          }
        },
        (err) => {
          this.order.closeSidebar();
          console.log(err);
        }
      );

    this.order.detectChanges();
  }
  //ماندن در صفحه دسترسی سریع
  StayOnFastAccessPage() {
    this.StayOnPage.emit();
  }
  setselectedItem(customer: Customer) {
    if (this.moreInfo === customer) this.moreInfo = null;
    else this.moreInfo = customer;
  }
  GetCustomerDetails(id: number) {
    this.httpCommonService
      .getItem("Customer/GetCustomerDetails", id)
      .pipe(take(1))
      .subscribe((customer: Customer) => {
        if (this.moreInfo?.Id === customer.Id) this.moreInfo = null;
        else this.moreInfo = customer;
        this.cd.markForCheck();
      });
  }
}
